import React, { useEffect, useState } from 'react';

import { SEO } from 'main/components';
import {
  ClassroomReadyKit,
  ClearCompliance,
  DroneSoccerAircraft,
  DroneSoccerLanding,
  DroneSoccerPartners,
  DroneSoccerRules,
  DroneSoccerSimulator,
  DroneSoccerSolutions,
  GhostProtocol,
} from 'modules/droneSoccer';

export const DroneSoccer = () => {
  const [windowWidth, setWindowWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <SEO seoTitle="Drone Soccer - Team Based Indoor Stem Sport - Orqa" />
      <section className="drone-soccer-section">
        <DroneSoccerLanding windowWidth={windowWidth} />
        <DroneSoccerPartners />
        <DroneSoccerAircraft />
        <GhostProtocol />
        <DroneSoccerSimulator />
        <DroneSoccerRules windowWidth={windowWidth} />
        <ClearCompliance />
        <ClassroomReadyKit windowWidth={windowWidth} />
        <DroneSoccerSolutions />
      </section>
    </>
  );
};
